@if (profissional()) {
<div class="drawer-header border-bottom">
  <span class="title">Detalhes do Profissional</span>
  <p-button (onClick)="closeModal()" icon="pi pi-times" [rounded]="true" [text]="true" severity="secondary" />
</div>
<div class="content-drawer">

  <div class="basic-info">
    <div class="avatar">
      <p-avatar
        *ngIf="!imageError && imagePreview; else defaultAvatar"
        [image]="$any(imagePreview)"
        shape="circle"
        size="xlarge"
        (onImageError)="imageError = true"
      />
      <ng-template #defaultAvatar>
        <p-avatar
          [label]="getInitials(profissional()?.nome)"
          [icon]="!profissional()?.nome ? 'pi pi-user' : undefined"
          shape="circle"
          size="xlarge"
        />
      </ng-template>
    </div>
    <div class="details">
      <h3 class="name">{{ profissional()?.nome }}</h3>
      <p class="description">{{ profissional()?.estado }}</p>
    </div>
  </div>

  <div class="d-flex justify-content-between gap-3 mt-4">
    <div class="card-info w-100">
      <div class="icon">
        <i class="pi pi-phone"></i>
      </div>
      <div class="description">
        <span class="title">Telefone</span>
        <span class="info">{{ profissional()?.telefonePrincipal }}</span>
      </div>
    </div>
    <div class="card-info w-100">
      <div class="icon">
        <i class="pi pi-envelope"></i>
      </div>
      <div class="description">
        <span class="title">Email</span>
        <span class="info">{{ profissional()?.email }}</span>
      </div>
    </div>
  </div>

  <!-- Acesso / Activação de Conta -->
  <div class="about mt-4 conta-acesso-box">
    <span class="title">Acesso ao Portal Profissional</span>
    <p class="mb-3">
      Se este profissional foi carregado automaticamente via SIASP e ainda não tem acesso,
      pode <strong>reforçar/ativar a conta</strong> para receber as credenciais e completar o perfil.
    </p>

    <div class="d-flex align-items-center gap-2 flex-wrap justify-content-end">
      <p-button label="Reforçar/Ativar Conta" icon="pi pi-user-check"
        [disabled]="isAccountLoading || !podeReforcarConta()" (onClick)="reforcarConta()" severity="success"></p-button>

      <!-- Estado/Contexto -->
      <p *ngIf="!profissional()?.email" class="text-sm text-color-secondary">
        ⚠️ Este registo não tem e-mail associado. Associe um e-mail antes de ativar a conta.
      </p>
      <!-- <p *ngIf="profissional()?.email && !podeReforcarConta()" class="text-sm text-color-secondary">
      ℹ️ Este profissional aparenta já ter conta activa ou não é oriundo do SIASP.
    </p> -->
    </div>
  </div>


  <div class="about mt-4">
    <span class="title">Sobre o profissional</span>
    <p>{{ profissional()?.sobreMim || 'Sem Dados' }}</p>
  </div>

  <div class="about mt-4">
    <span class="title">Formação acadêmica</span>
    @for (item of listaHabilitacoes; track $index) {
    <div class="education-card mt-3">
      <div class="graduation-icon">
        <!-- <img src="icons/graduation-grey.svg" alt=""> -->
      </div>
      <div class="info">
        <span class="course">{{item.designacao}}</span>
        <span class="institution">{{item.instituicao}}</span>
        <span class="period">{{item.dataInicio | date:'dd-MM-yyyy'}} - {{item.dataFim |
          date:'dd-MM-yyyy'}}</span>
      </div>
    </div>
    }
    <p *ngIf="!listaHabilitacoes || listaHabilitacoes.length === 0">Nenhuma formação acadêmica encontrada</p>
  </div>

  <div class="about mt-4">
    <span class="title">Histórico profissional</span>
    @for (item of listaExperiencias; track $index) {
    <div class="education-card mt-3">
      <div class="graduation-icon">
        <!-- <img src="icons/graduation-grey.svg" alt=""> -->
      </div>
      <div class="info">
        <span class="course">{{item.designacaoFuncao}}</span>
        <span class="institution">{{item.nomeEmpresa}}</span>
        <span class="period">
          {{item.dataInicio | date:'dd-MM-yyyy'}} - {{item.isActualEmprego ? "até ao momento." :
          (item.dataFim | date:'dd-MM-yyyy')}}
        </span>
        <!-- <p>
                    {{item.descricao}}
                </p> -->
      </div>
    </div>
    }
    <p *ngIf="!listaExperiencias || listaExperiencias.length === 0">Nenhuma experiência encontrada</p>

  </div>

  <div class="about mt-4">
    <span class="title">Competências</span>
    <div class="d-flex flex-wrap gap-2 align-items-center" *ngIf="listaCompetencias && listaCompetencias.length > 0">
      @for (item of listaCompetencias; track $index) {
      <div class="comp-chip">
        <span class="label"> {{item.competencia}}</span>
      </div>
      }
    </div>
    <p *ngIf="!listaCompetencias || listaCompetencias.length === 0">Nenhuma competência associada</p>
  </div>

  <div class="about mt-4">
    <span class="title">Línguas</span>
    <div class="card-content pt-3">
      <p-table [value]="listaLinguas" stripedRows [tableStyle]="{ 'width': '100%' }"
        *ngIf="listaLinguas && listaLinguas.length > 0">
        <ng-template #header>
          <tr>
            <th>Idioma</th>
            <th>Redação</th>
            <th>Fala</th>
            <th>Compreensão de Leitura</th>
          </tr>
        </ng-template>

        <ng-template #body let-lingua>
          <tr>
            <td>{{lingua.lingua.designacao}}</td>
            <td>{{getNivelByEnum(lingua.redacao)}}</td>
            <td>{{getNivelByEnum(lingua.fala)}}</td>
            <td>{{getNivelByEnum(lingua.leitura)}}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
    <p *ngIf="!listaLinguas || listaLinguas.length === 0">Nenhuma língua associada</p>
  </div>

</div>

}